import React from 'react';
import styles from './TermsOfService.module.css';
import help from "../../Images/help.png"

const terms = [
  {
    title: '1. Use of the Service',
    text: 'You agree to use the Service only for lawful purposes and in accordance with these Terms...'
  },
  {
    title: '2. Eligibility',
    text: 'You must be at least 13 years old to use our Service. By using the Service, you represent that you meet these requirements.'
  },
  {
    title: '3. User Accounts',
    text: 'To access certain features, you may be required to create an account. You are responsible for maintaining confidentiality...'
  },
  {
    title: '4. Intellectual Property',
    text: 'All content and materials on the Service are the intellectual property of [Your Company Name]...'
  },
  {
    title: '5. Prohibited Conduct',
    text: 'You agree not to: Use the Service for illegal purposes, violate laws, upload harmful code, harvest data, impersonate others...'
  },
  {
    title: '6. Termination',
    text: 'We reserve the right to suspend or terminate your access to the Service at our discretion...'
  },
  {
    title: '7. Disclaimer of Warranties',
    text: 'The Service is provided "as is" and "as available". We do not warrant that the Service will be error-free or uninterrupted...'
  },
  {
    title: '8. Limitation of Liability',
    text: '[Your Company Name] shall not be liable for any indirect or consequential damages...'
  },
  {
    title: '9. Modifications to the Service or Terms',
    text: 'We may update the Terms at any time. If changes are significant, we will notify you. Continued use means acceptance...'
  },
  {
    title: '10. Governing Law',
    text: 'These Terms are governed by and construed in accordance with the laws of your jurisdiction...'
  },
  {
    title: '11. Contact Us',
    text: 'If you have any questions, contact us:\n\n📧 Email: [your@email.com]\n📞 Phone: [Your contact number]\n🌐 Website: [Your website URL]'
  }
];

const TermsOfService = () => {
  return (
    <div className={styles.wrapper}>
      <h1 className={styles.heading}>Terms of Service</h1>
      <div className={styles.illustrationContainer}>
      <div className={styles.illustration}>
        {/* Optional: You can import and use an image here */}
        <img src={help} alt="Illustration" />
      </div>
      <div className={styles.grid}>
        {terms.map((term, index) => (
          <div className={styles.card} key={index}>
            <h3>{term.title}</h3>
            <p>{term.text}</p>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default TermsOfService;
